import { HealthScoreOverallStatus } from '../types';

const getLabelForStatus = (status?: HealthScoreOverallStatus): string => {
    const statusLabels: Record<string, string> = {
        healthy: 'Healthy',
        stable: 'Stable',
        at_risk: 'At Risk',
        critical: 'Critical',
    };

    return statusLabels[status || ''] || 'Unknown';
};

export default getLabelForStatus;
